var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"overflow":"hidden !important"},attrs:{"row":"","wrap":""}},[_vm._v("\n\n  test- "+_vm._s(_vm.localtz)+"- "+_vm._s(_vm.date)+" - "+_vm._s(_vm.time)+"\n \n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98dba2e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test.vue
// module id = null
// module chunks = 